// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-snackbar[data-v-7955dd18]{opacity:.8}.text[data-v-7955dd18]{font-weight:600;font-size:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
